import { useMemo } from 'react';

import { useListingStages } from '@/features/listing-stage/use-listing-stages.query';

import {
  DEFAULT_LISTING_STAGE_FILTERS,
  getSelectedListingStageIds,
} from './spotlight-listing-stage-filter.utils';

export {
  DEFAULT_STAGE_FILTERS,
  getSelectedListingStageIds,
} from './spotlight-listing-stage-filter.utils';

export const useSpotlightDefaultFilters = (): {
  filters: { isEditorChoice: boolean; listingStages: string[] };
  isReady: boolean;
} => {
  const { isLoading, listingStages } = useListingStages();
  const selectedListingStageIds = useMemo(
    () =>
      getSelectedListingStageIds(DEFAULT_LISTING_STAGE_FILTERS, listingStages),
    [listingStages],
  );
  const isReady = !isLoading && selectedListingStageIds.length > 0;
  const filters = useMemo(
    () => ({
      isEditorChoice: true,
      listingStages: selectedListingStageIds,
    }),
    [selectedListingStageIds],
  );

  return { filters, isReady };
};
